import type { ReactNode } from 'react';

export const symbol_airlines: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M194-220h517l97-520H551L194-220Zm-98 37 406-591q8-12 21.36-19 13.37-7 28.64-7h256q28.61 0 46.31 21.5Q872-757 867-729L765-184q-2 11-10.56 17.5-8.55 6.5-19.44 6.5H109q-9.39 0-13.7-7.5Q91-175 96-183Zm483.58-237q33.42 0 56.92-23.08 23.5-23.07 23.5-56.5 0-33.42-23.28-56.92t-57-23.5Q546-580 523-556.72t-23 57Q500-466 523.08-443q23.07 23 56.5 23ZM194-220h517-517Z"
		/>
	</svg>
);
